export default __webpack_public_path__ + "static/media/signin.d3f4043b.png";